(() => {
  if (window.FourPawUniversalGiftLifecycle) return;
  const marker = '_fourpaw_universal_gift';
  const registry = () => window.FourPawUniversalGiftRegistry || {};
  const productId = (item) => Number(item?.product_id || item?.product?.id || 0);
  const properties = (item) => item?.properties && typeof item.properties === 'object' ? item.properties : {};
  const readCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(`universal-gift-read-${response.status}`);
    return response.json();
  };
  const sectionIds = () => {
    const ids = new Set(['cart-drawer', 'cart-icon-bubble']);
    document.querySelector('cart-drawer')?.getSectionsToRender?.().forEach((section) => ids.add(section.id));
    return [...ids].filter(Boolean).slice(0, 5);
  };
  const correctCartCount = (cart) => {
    const universalQuantity = (cart?.items || []).reduce((sum, item) => (
      productId(item) === Number(registry().giftProductId) && properties(item)[marker] === 'classic-kit'
        ? sum + Number(item.quantity || 0)
        : sum
    ), 0);
    const count = Math.max(0, Number(cart?.item_count || 0) - universalQuantity);
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.hidden = count <= 0;
    const visible = bubble.querySelector('[aria-hidden="true"]');
    if (visible) visible.textContent = String(count);
    const accessible = bubble.querySelector('.visually-hidden');
    const template = count === 1 ? registry().cartCountOne : registry().cartCountMany;
    if (accessible && template) accessible.textContent = template.replace('[count]', String(count));
  };
  const render = (body) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && body?.sections?.['cart-drawer']) drawer.renderContents(body);
    const bubbleHtml = body?.sections?.['cart-icon-bubble'];
    if (bubbleHtml) {
      const fresh = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('#cart-icon-bubble');
      const current = document.querySelector('#cart-icon-bubble');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    correctCartCount(body);
  };
  const refreshSections = async (cart) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(`universal-gift-sections-${response.status}`);
    render({ ...cart, sections: await response.json() });
  };
  const write = async (url, body) => {
    const response = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ ...body, sections: sectionIds(), sections_url: window.location.pathname }) });
    if (!response.ok) throw new Error(`universal-gift-write-${response.status}`);
    const result = await response.json();
    correctCartCount(result);
    await new Promise((resolve) => window.setTimeout(resolve, 500));
    await refreshSections(await readCart());
    return result;
  };
  const classify = (cart) => {
    const config = registry();
    const qualifiers = new Set((config.qualifierProductIds || []).map(Number));
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const quantity = items.reduce((sum, item) => qualifiers.has(productId(item)) ? sum + Number(item.quantity || 0) : sum, 0);
    const gifts = items.filter((item) => productId(item) === Number(config.giftProductId) && properties(item)[marker] === 'classic-kit');
    return { quantity, gifts };
  };
  let syncing = false;
  let timer = 0;
  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await readCart();
      correctCartCount(cart);
      const state = classify(cart);
      const primary = state.gifts[0];
      if (state.gifts.length > 1) {
        const updates = {};
        state.gifts.slice(1).forEach((item) => { updates[item.key] = 0; });
        await write('/cart/update.js', { updates });
      }
      if (state.quantity <= 0 && primary) await write('/cart/change.js', { id: primary.key, quantity: 0 });
      else if (state.quantity > 0 && !primary) await write('/cart/add.js', { items: [{ id: Number(registry().giftVariantId), quantity: state.quantity, properties: { [marker]: 'classic-kit' } }] });
      else if (primary && Number(primary.quantity) !== state.quantity) await write('/cart/change.js', { id: primary.key, quantity: state.quantity });
    } catch (error) {
      document.dispatchEvent(new CustomEvent('fourpaw:universal-gift-error', { detail: { message: error.message } }));
    } finally {
      syncing = false;
    }
  };
  const schedule = () => { window.clearTimeout(timer); timer = window.setTimeout(sync, 80); };
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const url = String(args[0]?.url || args[0] || '');
    if (/\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url) && !syncing) schedule();
    return response;
  };
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', () => window.clearTimeout(timer));
  document.addEventListener('shopify:block:select', schedule);
  window.FourPawUniversalGiftLifecycle = { classify, schedule, sync };
})();
